import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import styles from "../styles";
import Text from "../../../../../Diathrive/src/components/elements/Text";
import {
  BUTTON_TYPES,
  COLORS,
} from "../../../../../Diathrive/src/utils/Constants";
import Button from "../../../../../Diathrive/src/components/elements/Button";
import { NoAdvisors } from "../../../../../Diathrive/src/utils/SvgIcons";
import {
  APPOINTMENTS,
  HTTP_METHODS,
} from "../../../../../Diathrive/src/utils/URLConstants";
import { fetchApi } from "../../../../../Diathrive/src/utils/ApiHelper";

const NextAppointments = () => {
  const [appointments, setAppointments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchApi(HTTP_METHODS.GET, APPOINTMENTS)
      .then((response) => {
        const all = response.data.data.appointments || [];
        const now = new Date();
        const upcoming = all
          .filter(
            (a) =>
              new Date(a.startTime) > now && a.status !== "cancelled"
          )
          .sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
          .slice(0, 2);
        setAppointments(upcoming);
      })
      .catch(() => {});
  }, []);

  if (appointments.length === 0) {
    return (
      <>
        <Text color={COLORS.blueDarkText} variation="Subtitle2Bold">
          Next Appointments
        </Text>
        <div style={styles.noAppointmentsText}>
          <NoAdvisors />
          <br />
          <Text color={COLORS.blueDarkText} variation="Body1SemiBold">
            No advisors yet.
          </Text>
          <br />
          <Text color={COLORS.grey1} variation="Subtitle2Regular">
            Health Advisors are Certified Diabetes Care and Education Specialists
            (CDCES) and can help you manage lifestyle changes, medication and
            more.
          </Text>
        </div>
        <div>
          <Button
            buttonType={BUTTON_TYPES.Filled}
            title={"Schedule First Appointment"}
            titleColor={COLORS.white}
            onPress={() => navigate("/advising")}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <Text color={COLORS.blueDarkText} variation="Subtitle2Bold">
        Next Appointments
      </Text>
      {appointments.map((appt, index) => (
        <div
          key={appt.id || index}
          style={{
            marginTop: 16,
            padding: 12,
            borderRadius: 12,
            backgroundColor: "#F8F9FC",
          }}
        >
          <Text variation="Text2Medium" color={COLORS.grey2}>
            {moment(appt.startTime).format("MMM D, YYYY • hh:mm A")}
          </Text>
          <Text
            variation="Body1SemiBold"
            color={COLORS.black}
            topMargin={4}
          >
            {appt.advisor.firstname + " " + appt.advisor.lastname}
          </Text>
          <Text variation="Text2Medium" color={COLORS.grey2} topMargin={4}>
            {appt.eventType === "Video" ? "Video Call" : "Phone Call"}
          </Text>
        </div>
      ))}
      <div style={{ marginTop: 16 }}>
        <Button
          buttonType={BUTTON_TYPES.Bordered}
          title={"View All"}
          onPress={() => navigate("/advising")}
        />
      </div>
    </>
  );
};

export default NextAppointments;
